/*eslint-disable */
import {
  mapGetters
} from 'vuex';
const $ = window.jQuery = require('jquery');  
import toast from '@/services/toast';
import { Datetime } from 'vue-datetime';
import { VueEditor } from "vue2-editor";
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
export default {
  name: 'emplooye-task-add',
  components: {
    datetime: Datetime,
    VueEditor
  },
  props: [],
  data () {
    return {
      submitted:false,
      title:'',
      content:'',
      start_date:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
      empTaskInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'getEmployeeTaskInfoByIdGetters'
    ]),
    getEmpTaskInfoByIdFun() {
      this.empTaskInfo = this.$store.getters.getEmployeeTaskInfoByIdGetters.data
      return
    },
    setInitialState(){
      if(this.empTaskInfo){
        this.title = this.empTaskInfo.title
        this.content = this.empTaskInfo.content
        this.start_date = this.empTaskInfo.start_date
      }
      return
    }
  },
  mounted () {
    this.getEmpTaskInfoByIdFun
    this.setInitialState
  },
  methods: {
    validateTaskBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
            let data = {
              title:this.title,
              content:this.content,
              start_date:this.start_date
            }
            this.$store.dispatch('updateEmployeeTaskFun', {data:{id:this.$route.params.updateID,data:data}})
              .then((res) => {  
                  toast.success(res.data.msg);           
                  this.submitted = false;
                  this.$router.push({ name: 'employeeTaskList'})
              }).catch((err) => {        
                this.submitted = false;
                toast.error(err.data.user_msg || err.data.msg);
              })
            return;
        }
      });
    }
  },
  watch:{
    getEmpTaskInfoByIdFun() {
      return this.$store.getters.getEmployeeTaskInfoByIdGetters
    },
    setInitialState(){
      if(this.empTaskInfo){
        this.title = this.empTaskInfo.title
        this.content = this.empTaskInfo.content
        this.start_date = this.empTaskInfo.start_date
      }
      return
    }
  }
}


